<ngx-loading-bar [includeSpinner]="false" [height]="'3px'"></ngx-loading-bar>

<router-outlet></router-outlet>

<p-toast />
